module.exports = __webpack_public_path__ + "img/promotion-boost.f2c3d804.svg";